import { Button, Form, Row } from "antd";

import { IGiveawayAuto, IGiveawayHistory, IPanelUser } from "../../../../../interfaces";

import useExportData from "./useExportData";
import FileAndHashContainer from "../../components/FileAndHashContainer";
import { formatDateStringToDateAndTime } from "../../../../../utils/Conversores";

interface IProps {
    giveawayAuto: IGiveawayAuto | undefined;
    lastGiveawayHistory: IGiveawayHistory | undefined;
    panelUserGeneratedParticipantsFile?: IPanelUser;
    onTicketsFileGenerated: (hash: string, file: string) => void;
}

export default function ExportData({ giveawayAuto, lastGiveawayHistory, panelUserGeneratedParticipantsFile, onTicketsFileGenerated }: IProps) {
    const {
        isExportingTickets,
        isDownloadingFile,
        hash,
        file,
        handleClickExportTickets,
        handleClickDownloadFile,
    } = useExportData({ giveawayAuto, lastGiveawayHistory, onTicketsFileGenerated });

    if (!giveawayAuto) {
        return null;
    }

    return (
        <Form
            autoComplete='off'
            layout='vertical'
        >
            {
                !hash && (
                    <Row
                        justify="center"
                        style={{
                            marginTop: 32,
                        }}
                    >
                        <Button
                            onClick={handleClickExportTickets}
                            type="primary"
                            htmlType="button"
                            disabled={isExportingTickets}
                            loading={isExportingTickets}
                        >
                            Gerar arquivo com os bilhetes
                        </Button>
                    </Row>
                )
            }

            {
                file && hash && (
                    <FileAndHashContainer
                        hash={hash}
                        file={file}
                        downloadFileButtonLabel="Fazer download do arquivo de bilhetes"
                        fileInfoLabel={panelUserGeneratedParticipantsFile && `Arquivo gerado em ${formatDateStringToDateAndTime(giveawayAuto?.participants_file_generated_at)} por ${panelUserGeneratedParticipantsFile.name}`}
                        isDownloadingFile={isDownloadingFile}
                        onClickDownloadFile={handleClickDownloadFile}
                    />
                )
            }
        </Form>
    )
}
